module.exports = __webpack_public_path__ + "static/media/single-user.ed537ff4.svg";